import React, { createContext, type ReactNode, useState } from 'react';

export type CommsContextType = {
  searchString: string;
  setSearchString: (newString: string) => void;
  isAdmin: boolean;
  setIsAdmin: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CommsContext = createContext<CommsContextType | null>(null);

interface ICommsContextProvider {
  children: ReactNode;
}
export const CommsContextProvider = ({ children }: ICommsContextProvider) => {
  const [searchString, setSearchString] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  return (
    <CommsContext
      value={{
        searchString,
        setSearchString,
        isAdmin,
        setIsAdmin,
      }}
    >
      {children}
    </CommsContext>
  );
};
